import { render, staticRenderFns } from "./MarketplaceProductsShop.vue?vue&type=template&id=8ae1c4b0&scoped=true"
import script from "./MarketplaceProductsShop.vue?vue&type=script&lang=js"
export * from "./MarketplaceProductsShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae1c4b0",
  null
  
)

export default component.exports